import { omniAtom } from "src/utils/atoms";

export const settingsAtom = omniAtom({
	key: "showSettings",
	value: false,
});
